import { UnifiedCTA } from "@/components/shared/UnifiedCTA";

export const FinalCTA = () => {
  return (
    <UnifiedCTA
      headline="Talk to a Travel Expert Before You Book"
      subtext="Get personalized advice and a custom itinerary from our experienced travel coordinators. No pressure, just expert guidance."
      primaryButtonText="Plan My Trip"
      primaryButtonLink="/contact"
      showPhoneIcon={true}
      secondaryButtonText="Call Our Expert"
      secondaryButtonHref="tel:+917490019959"
      footerText="📞 +91 74900 19959 • Available Mon-Sat, 10 AM - 7 PM IST"
    />
  );
};
